module.exports = {"validation":{"required":"Ce champ est obligatoire","email":"Adresse e-mail invalide"}}